export class RenderBuffer {
  constructor(gl) {
    /*
        WebGL API のWebGLRenderingContext.createFramebuffer()メソッドは、オブジェクトを作成して初期化します WebGLFramebuffer
        レンダーバッファや、カラーバッファ用のテクスチャは、最終的にフレームバッファと紐付けすることで初めて利用可能になります。続いてはフレームバッファについて見ていきましょう。フレームバッファは、レンダーバッファと同じようにまずは生成するところからスタートします。そして、やはりここでも、バインドすることによって操作を加えることが可能になります。
        フレームバッファの生成にはcreateFramebufferメソッドを使います。生成されたフレームバッファをバインドするためのメソッドがbindFramebufferですね。ここでは第一引数にgl.FRAMEBUFFERという組み込み定数を使い、第二引数に実際にバインドするフレームバッファを指定します。ここまでは非常に簡単ですね。続いて、フレームバッファにレンダーバッファやテクスチャを紐付けます。今回は、深度バッファとしてレンダーバッファを、カラーバッファとしてテクスチャを使う想定で見てみます。
    */
    this.framebuffer = gl.createFramebuffer();
    this.texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.canvas.width, gl.canvas.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0);

    this.depthBuffer = gl.createRenderbuffer();
    gl.bindRenderbuffer(gl.RENDERBUFFER, this.depthBuffer);

    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, gl.canvas.width, gl.canvas.height);
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, this.depthBuffer);
  }

  bind(gl) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
  }

  clear(gl) {
    this.bind(gl);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  }
}

// export class RenderBuffer {
//     constructor(gl) {
//         this.framebuffer = gl.createFramebuffer();
//         this.texture = gl.createTexture();

//         gl.bindTexture(gl.TEXTURE_2D, this.texture);
//         gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.canvas.width, gl.canvas.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);

//         gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
//         gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
//         gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

//         gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
//         gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0);

//         this.depthBuffer = gl.createRenderbuffer();
//         gl.bindRenderbuffer(gl.RENDERBUFFER, this.depthBuffer);

//         gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, gl.canvas.width, gl.canvas.height);
//         gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, this.depthBuffer);
//     }

//     bind(gl) {
//         gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
//     }

//     clear(gl) {
//         this.bind(gl);
//         gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
//     }
// }
